import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AdminGate from './pages/AdminGate';
import { AdminAuthProvider } from './context/AdminAuthContext';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/admin"
          element={
            <AdminAuthProvider>
              <AdminGate />
            </AdminAuthProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;